var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPatternRed = function SvgPatternRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pattern-red_svg__a",
    d: "M.354.354h16v16h-16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-.35 -.35)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pattern-red_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern-red_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AC493A",
    d: "M.707 16.707 0 16 16 0l.707.707zm-4-4L-4 12 12-4l.707.707z",
    mask: "url(#pattern-red_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.8,
    fillRule: "nonzero",
    d: "M-7.293 8.707-8 8 8-8l.707.707z",
    mask: "url(#pattern-red_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AC493A",
    d: "M4.707 20.707 4 20 20 4l.707.707z",
    mask: "url(#pattern-red_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.8,
    fillRule: "nonzero",
    d: "M8.707 24.707 8 24 24 8l.707.707z",
    mask: "url(#pattern-red_svg__b)"
  }))));
};
export { SvgPatternRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxkZWZzPjxwYXRoIGlkPSJwYXR0ZXJuLXJlZC1hIiBkPSJNLjM1NC4zNTRoMTZ2MTZoLTE2eiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0uMzUgLS4zNSkiPjxtYXNrIGlkPSJwYXR0ZXJuLXJlZC1iIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNwYXR0ZXJuLXJlZC1hIi8+PC9tYXNrPjxwYXRoIGZpbGw9IiNBQzQ5M0EiIG1hc2s9InVybCgjcGF0dGVybi1yZWQtYikiIGQ9Ik0uNzA3IDE2LjcwN0wwIDE2IDE2IDBsLjcwNy43MDd6TS0zLjI5MyAxMi43MDdMLTQgMTIgMTItNGwuNzA3LjcwN3oiLz48cGF0aCBmaWxsPSIjMDAwIiBmaWxsLW9wYWNpdHk9Ii44IiBmaWxsLXJ1bGU9Im5vbnplcm8iIG1hc2s9InVybCgjcGF0dGVybi1yZWQtYikiIGQ9Ik0tNy4yOTMgOC43MDdMLTggOCA4LThsLjcwNy43MDd6Ii8+PHBhdGggZmlsbD0iI0FDNDkzQSIgbWFzaz0idXJsKCNwYXR0ZXJuLXJlZC1iKSIgZD0iTTQuNzA3IDIwLjcwN0w0IDIwIDIwIDRsLjcwNy43MDd6Ii8+PHBhdGggZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuOCIgZmlsbC1ydWxlPSJub256ZXJvIiBtYXNrPSJ1cmwoI3BhdHRlcm4tcmVkLWIpIiBkPSJNOC43MDcgMjQuNzA3TDggMjQgMjQgOGwuNzA3LjcwN3oiLz48L2c+PC9zdmc+Cg==";